import classNames from "classnames/bind";
import { useTranslation } from "react-i18next";

import { GAME_IMAGE_ATTRS } from "../../../../../constants";
import { isQuickPickGame } from "../../../../../graphql/helpers/isQuickPickGame";
import { QuickPickGameKind } from "../../ProjectSettings/Steps/AddGames/AddGameForm/AddGameForm";
import { useGame } from "../../../../../contexts/game/GameContext";

import styles from "./GameList.module.scss";
import { isWordleGame } from "../../../../../graphql/helpers/isWordleGame";

const cx = classNames.bind(styles);

export const GameList = () => {
  const { t } = useTranslation();
  const { currentGame, games, setCurrentGame } = useGame();

  return (
    <div className={styles.gameList}>
      {games.length > 0 && <h6 className={styles.header}>{t("project:gameList")}:</h6>}
      {games.map((game, index) => (
        <button
          key={index}
          className={cx("game", { active: game.id === currentGame?.id })}
          onClick={() => setCurrentGame(game)}
        >
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img
            className={cx("gameImage", { wordle: isWordleGame(game) })}
            {...GAME_IMAGE_ATTRS[isQuickPickGame(game) ? QuickPickGameKind.QuickPick : game?.kind]}
          />
          <span className={styles.gameName}>{game.name}</span>
        </button>
      ))}
    </div>
  );
};
